import { isEmail, isNullOrUndefined, isPhone } from "../helpers/Utils";

export interface IRecipientDetails {
    firstName: string;
    firstNameIsValid: boolean;
    lastName: string;
    lastNameIsValid: boolean;
    email: string;
    emailIsValid: boolean;
    phone: string;

    //isValid(): boolean;
}

export class RecipientDetailsModel implements IRecipientDetails {
    firstName: string;
    firstNameIsValid: boolean;
    lastName: string;
    lastNameIsValid: boolean;
    email: string;
    emailIsValid: boolean;
    phone: string;

    constructor(
    ) {
        this.firstNameIsValid = true;
        this.lastNameIsValid = true;
        this.emailIsValid = true;
    }

    static validateModel(
        model: IRecipientDetails,
        emailIsRequired: boolean,
        phoneIsRequired: boolean): boolean {

        if (!model) return false;

        let emailIsValid = !emailIsRequired;
        if (emailIsRequired) {
            emailIsValid = (model.email?.trim() && isEmail(model.email));
            model.emailIsValid = emailIsValid;
        }

        if (phoneIsRequired) {
            if (!model.phone) {
                return false;
            }

            let phoneNumberRegex;

            if (model.phone.startsWith("+44")) {
                phoneNumberRegex = /^\+447\d{9}$/;
            } else if (model.phone.startsWith("+353")) {
                phoneNumberRegex = /^\+3538\d{8}$/;
            } else {
                return false;
            }

            if (phoneNumberRegex.test(model.phone) === false) {
                return false;
            }
        }

        if (model.firstName?.trim()
            && model.lastName?.trim()
            && emailIsValid) {
            model.firstNameIsValid = true;
            model.lastNameIsValid = true;
            model.emailIsValid = true;
            return true;
        }

        if (!model.firstName?.trim()) {
            model.firstNameIsValid = false;
        } else {
            model.firstNameIsValid = true;
        }

        if (!model.lastName?.trim()) {
            model.lastNameIsValid = false;
        } else {
            model.lastNameIsValid = true;
        }

        if (!emailIsValid) {
            model.emailIsValid = false;
        } else {
            model.emailIsValid = true;
        }

        return false;
    }

     //[obsolete: use static validateModel instead]
    isValid():boolean {
        return (
            false
        );
    }
}